var _g, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBalance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_208_10967)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 32C21.606 32 18 30.948 18 29C18 28.724 18.224 28.5 18.5 28.5C18.776 28.5 19 28.724 19 29C19 29.835 21.282 31 25 31C28.718 31 31 29.835 31 29C31 28.724 31.224 28.5 31.5 28.5C31.776 28.5 32 28.724 32 29C32 30.948 28.394 32 25 32Z",
    fill: "#485057"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 29C21.606 29 18 27.948 18 26C18 25.724 18.224 25.5 18.5 25.5C18.776 25.5 19 25.724 19 26C19 26.835 21.282 28 25 28C28.718 28 31 26.835 31 26C31 25.724 31.224 25.5 31.5 25.5C31.776 25.5 32 25.724 32 26C32 27.948 28.394 29 25 29Z",
    fill: "#485057"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 26C21.606 26 18 24.948 18 23C18 21.052 21.606 20 25 20C28.394 20 32 21.052 32 23C32 24.948 28.394 26 25 26ZM25 21C21.282 21 19 22.165 19 23C19 23.835 21.282 25 25 25C28.718 25 31 23.835 31 23C31 22.165 28.718 21 25 21Z",
    fill: "#485057"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5 29.5C31.224 29.5 31 29.276 31 29V23C31 22.724 31.224 22.5 31.5 22.5C31.776 22.5 32 22.724 32 23V29C32 29.276 31.776 29.5 31.5 29.5Z",
    fill: "#485057"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 29.5C18.224 29.5 18 29.276 18 29V23C18 22.724 18.224 22.5 18.5 22.5C18.776 22.5 19 22.724 19 23V29C19 29.276 18.776 29.5 18.5 29.5Z",
    fill: "#485057"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 20C11.606 20 8 18.948 8 17C8 16.724 8.224 16.5 8.5 16.5C8.776 16.5 9 16.724 9 17C9 17.835 11.282 19 15 19C18.718 19 21 17.835 21 17C21 16.724 21.224 16.5 21.5 16.5C21.776 16.5 22 16.724 22 17C22 18.948 18.394 20 15 20Z",
    fill: "#485057"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 17C11.606 17 8 15.948 8 14C8 13.724 8.224 13.5 8.5 13.5C8.776 13.5 9 13.724 9 14C9 14.835 11.282 16 15 16C18.718 16 21 14.835 21 14C21 13.724 21.224 13.5 21.5 13.5C21.776 13.5 22 13.724 22 14C22 15.948 18.394 17 15 17Z",
    fill: "#485057"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 26C11.606 26 8 24.948 8 23C8 22.724 8.224 22.5 8.5 22.5C8.776 22.5 9 22.724 9 23C9 23.835 11.282 25 15 25C15.544 25 16.018 24.978 16.447 24.933C16.718 24.903 16.968 25.103 16.997 25.377C17.026 25.651 16.827 25.898 16.553 25.927C16.087 25.977 15.579 26 15 26V26Z",
    fill: "#485057"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 29C11.606 29 8 27.948 8 26C8 25.724 8.224 25.5 8.5 25.5C8.776 25.5 9 25.724 9 26C9 26.835 11.282 28 15 28C15.544 28 16.018 27.978 16.447 27.933C16.718 27.898 16.968 28.103 16.997 28.377C17.026 28.651 16.827 28.898 16.553 28.927C16.087 28.977 15.579 29 15 29V29Z",
    fill: "#485057"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 23C11.606 23 8 21.948 8 20C8 19.724 8.224 19.5 8.5 19.5C8.776 19.5 9 19.724 9 20C9 20.835 11.282 22 15 22C15.544 22 16.018 21.978 16.447 21.933C16.718 21.901 16.968 22.102 16.997 22.377C17.026 22.651 16.827 22.898 16.553 22.927C16.087 22.977 15.579 23 15 23V23Z",
    fill: "#485057"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 14C11.606 14 8 12.948 8 11C8 9.052 11.606 8 15 8C18.394 8 22 9.052 22 11C22 12.948 18.394 14 15 14ZM15 9C11.282 9 9 10.165 9 11C9 11.835 11.282 13 15 13C18.718 13 21 11.835 21 11C21 10.165 18.718 9 15 9Z",
    fill: "#485057"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 26.5C8.224 26.5 8 26.276 8 26V11C8 10.724 8.224 10.5 8.5 10.5C8.776 10.5 9 10.724 9 11V26C9 26.276 8.776 26.5 8.5 26.5Z",
    fill: "#485057"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5 17.5C21.224 17.5 21 17.276 21 17V11C21 10.724 21.224 10.5 21.5 10.5C21.776 10.5 22 10.724 22 11V17C22 17.276 21.776 17.5 21.5 17.5Z",
    fill: "#485057"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "#485057",
    strokeOpacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_208_10967"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalance);
export default __webpack_public_path__ + "static/media/Balance.652121d9e0f98abe27339cbded2adcba.svg";
export { ForwardRef as ReactComponent };